import React from 'react';
import {
  filledCampaignAttribution,
  type CampaignAttribution,
} from '../../api/campaignAttribution';

const CampaignAttributionDetails: React.FC<{ row: Partial<CampaignAttribution> }> = ({ row }) => {
  const entries = filledCampaignAttribution(row);
  return (
    <>
      <h4 className="website-lead-subheading">Campaign attribution</h4>
      {entries.length === 0 ? (
        <p className="page-subtitle">No campaign parameters (organic or direct visit).</p>
      ) : (
        <dl className="website-lead-details">
          {entries.map((entry) => (
            <div key={entry.label}>
              <dt>{entry.label}</dt>
              <dd>{entry.value}</dd>
            </div>
          ))}
        </dl>
      )}
    </>
  );
};

export default CampaignAttributionDetails;
